import { render, staticRenderFns } from "./TUTJ.vue?vue&type=template&id=0a047f8d&"
import script from "./TUTJ.vue?vue&type=script&lang=js&"
export * from "./TUTJ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports